<template>
  <v-content>
    <router-view />
  </v-content>
</template>

<script>
export default {}
</script>

<style>
</style>